import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "color", "width", "height", "stroke"];
import React from 'react';
var WarningIcon = function WarningIcon(_ref) {
  var className = _ref.className,
    color = _ref.color,
    width = _ref.width,
    height = _ref.height,
    stroke = _ref.stroke,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: width || 'auto',
    height: height || '25',
    viewBox: "0 0 26 25"
  }, rest), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 .5)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: stroke || '#FFF',
    strokeWidth: "2",
    d: "M12.887 1.7l10.35 19.837A1 1 0 0 1 22.35 23H1.65a1 1 0 0 1-.887-1.463L11.113 1.7a1 1 0 0 1 1.774 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "2",
    height: "7.5",
    x: "11",
    y: "9",
    fill: stroke || '#FFF',
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "2",
    height: "2",
    x: "11",
    y: "17.5",
    fill: stroke || '#FFF',
    rx: "1",
    transform: "matrix(1 0 0 -1 0 37)"
  })));
};
export default WarningIcon;